// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-modal .modal-header {
    display: flex;
    justify-content: space-between;
}
.profile-modal .modal-body {
    padding-top: 1.5rem;
}
.profile-modal .btn-center {
    max-width: 400px;
    margin: 3rem auto 0 auto;
}
.select-opation--wrapper > div label {
    position: relative;
    color: var(--white);
}
.select-opation--wrapper > div {
    width: 100%;
    color: var(--white);
}
.select-opation--wrapper input {
    padding: 8.5px 4px 8.5px 5px !important;
    color: var(--white);
}
.select-opation--wrapper button svg{
    fill: var(--whiteLight);
}
.select-opation--wrapper fieldset,
.cstm-phone--input .MuiAutocomplete-root fieldset,
.select-opation--wrapper [class*="-MuiOutlinedInput-roo"]:hover fieldset,
.cstm-phone--input .MuiAutocomplete-root [class*="-MuiOutlinedInput-roo"]:hover fieldset{
    border-color: rgb(255 255 255/40% );
}
.cstm-phone--input .MuiAutocomplete-root fieldset {
    border-right: none;
    border-radius: 4px 0 0 4px;
    height: 62px;
}
.cstm-phone--input .MuiAutocomplete-root>div{
    width: 100px;
    margin-bottom: 2px;
    background-color: var(--green);
}
.cstm-phone--input .MuiFormControl-root + form{
    width: calc(100% - 97px);
}
.select-opation--wrapper .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
    background-color: var(--darkGreen);
}

.cstm-phone--input .MuiInputBase-root input {
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding-left: 0;
    color: var(--white);
}
.cstm-phone--input .MuiFormControl-root + form label {
    transform: translateX(-100px);
    font-size: 78%;
}
.cstm-phone--input .MuiAutocomplete-root svg.MuiSvgIcon-root {
    fill: rgb(255 255 255/40% );
}
.cstm-file--input{
    position: relative;
}
.cstm-file--input input[type="file"] {
    padding-right: 110px;
    cursor: pointer;
    color: rgb(255 255 255/50%);
}
.cstm-file--input input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
    display: none;
}
.cstm-file--input button.file-upload--btn {
    position: absolute;
    right: 1px;
    bottom: 1px;
    background: rgb(255 255 255/50%);
    height: calc(100% - 26px);
    font-size: 16px;
    color: var(--darkGreen);
    padding: 0.5rem 1rem;
    border: 1px solid #707070;
    pointer-events: none;
}
.profile-modal .input-box .input-label,
.profile-modal .select-opation--wrapper > div label{
    color: rgb(255 255 255/50%);
}
.cstm-phone--input .cstm-label {
    font-size: 16px;
    margin-bottom: 2px;
    color: rgb(255 255 255/50%);
    font-family: 'Acumin Pro';
}
.cstm-phone--input .PhoneInputCountry{
    margin: 0;
    padding-right: 10px;
    padding-left: 10px;
    border: 1px solid var(--whiteLight);
    border-right: none;
    border-radius: 4px 0 0 4px;
}

.cstm-phone--input input.PhoneInputInput {
    outline: none;
    height: 48px;
    background: var(--darkGreen);
    border: 1px solid  var(--whiteLight);
    border-width: 1px;
    border-radius: 0 4px 4px 0;
    border-left: 0;
    color: var(--white);
    font-size: 16px;
    font-family: 'Acumin Pro';
    font-weight: 400;
}

/* making Select component gray by default */
.profile-modal .form-group .MuiFormControl-root .MuiInputBase-root,
.profile-modal .form-group .MuiFormControl-root .MuiInputBase-root.Mui-focused {
    background-color: var(--darkGreen);
    color: var(--white);
}

.profile-modal .form-group .MuiInputLabel-root,
.profile-modal .form-group .MuiSelect-icon {
    color: rgb(255 255 255/50%);
    
}

.profile-modal .form-group .MuiSelect-select,
.profile-modal .form-group .MuiSelect-select.Mui-focused,
.profile-modal .form-group .MuiSelect-select:focus {
    background-color: var(--darkGreen);
    color: var(--white);
    
}

.profile-modal .form-group .MuiOutlinedInput-notchedOutline {
    border-color: rgb(255 255 255/40%);
}

.profile-modal .form-group .MuiSelect-icon {
    fill: rgb(255 255 255/40%);
}

.profile-modal .form-group .dropdown {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Screens/MyPatients/components/AddPatients/AddPatients.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,uCAAuC;IACvC,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;;;;IAII,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,oBAAoB;AACxB;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,oCAAoC;IACpC,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;;IAEI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;;AAE/B;;AAEA;;;IAGI,kCAAkC;IAClC,mBAAmB;;AAEvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".profile-modal .modal-header {\n    display: flex;\n    justify-content: space-between;\n}\n.profile-modal .modal-body {\n    padding-top: 1.5rem;\n}\n.profile-modal .btn-center {\n    max-width: 400px;\n    margin: 3rem auto 0 auto;\n}\n.select-opation--wrapper > div label {\n    position: relative;\n    color: var(--white);\n}\n.select-opation--wrapper > div {\n    width: 100%;\n    color: var(--white);\n}\n.select-opation--wrapper input {\n    padding: 8.5px 4px 8.5px 5px !important;\n    color: var(--white);\n}\n.select-opation--wrapper button svg{\n    fill: var(--whiteLight);\n}\n.select-opation--wrapper fieldset,\n.cstm-phone--input .MuiAutocomplete-root fieldset,\n.select-opation--wrapper [class*=\"-MuiOutlinedInput-roo\"]:hover fieldset,\n.cstm-phone--input .MuiAutocomplete-root [class*=\"-MuiOutlinedInput-roo\"]:hover fieldset{\n    border-color: rgb(255 255 255/40% );\n}\n.cstm-phone--input .MuiAutocomplete-root fieldset {\n    border-right: none;\n    border-radius: 4px 0 0 4px;\n    height: 62px;\n}\n.cstm-phone--input .MuiAutocomplete-root>div{\n    width: 100px;\n    margin-bottom: 2px;\n    background-color: var(--green);\n}\n.cstm-phone--input .MuiFormControl-root + form{\n    width: calc(100% - 97px);\n}\n.select-opation--wrapper .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] {\n    background-color: var(--darkGreen);\n}\n\n.cstm-phone--input .MuiInputBase-root input {\n    border-left: none;\n    border-radius: 0 4px 4px 0;\n    padding-left: 0;\n    color: var(--white);\n}\n.cstm-phone--input .MuiFormControl-root + form label {\n    transform: translateX(-100px);\n    font-size: 78%;\n}\n.cstm-phone--input .MuiAutocomplete-root svg.MuiSvgIcon-root {\n    fill: rgb(255 255 255/40% );\n}\n.cstm-file--input{\n    position: relative;\n}\n.cstm-file--input input[type=\"file\"] {\n    padding-right: 110px;\n    cursor: pointer;\n    color: rgb(255 255 255/50%);\n}\n.cstm-file--input input[type=\"file\"]::-webkit-file-upload-button {\n    visibility: hidden;\n    display: none;\n}\n.cstm-file--input button.file-upload--btn {\n    position: absolute;\n    right: 1px;\n    bottom: 1px;\n    background: rgb(255 255 255/50%);\n    height: calc(100% - 26px);\n    font-size: 16px;\n    color: var(--darkGreen);\n    padding: 0.5rem 1rem;\n    border: 1px solid #707070;\n    pointer-events: none;\n}\n.profile-modal .input-box .input-label,\n.profile-modal .select-opation--wrapper > div label{\n    color: rgb(255 255 255/50%);\n}\n.cstm-phone--input .cstm-label {\n    font-size: 16px;\n    margin-bottom: 2px;\n    color: rgb(255 255 255/50%);\n    font-family: 'Acumin Pro';\n}\n.cstm-phone--input .PhoneInputCountry{\n    margin: 0;\n    padding-right: 10px;\n    padding-left: 10px;\n    border: 1px solid var(--whiteLight);\n    border-right: none;\n    border-radius: 4px 0 0 4px;\n}\n\n.cstm-phone--input input.PhoneInputInput {\n    outline: none;\n    height: 48px;\n    background: var(--darkGreen);\n    border: 1px solid  var(--whiteLight);\n    border-width: 1px;\n    border-radius: 0 4px 4px 0;\n    border-left: 0;\n    color: var(--white);\n    font-size: 16px;\n    font-family: 'Acumin Pro';\n    font-weight: 400;\n}\n\n/* making Select component gray by default */\n.profile-modal .form-group .MuiFormControl-root .MuiInputBase-root,\n.profile-modal .form-group .MuiFormControl-root .MuiInputBase-root.Mui-focused {\n    background-color: var(--darkGreen);\n    color: var(--white);\n}\n\n.profile-modal .form-group .MuiInputLabel-root,\n.profile-modal .form-group .MuiSelect-icon {\n    color: rgb(255 255 255/50%);\n    \n}\n\n.profile-modal .form-group .MuiSelect-select,\n.profile-modal .form-group .MuiSelect-select.Mui-focused,\n.profile-modal .form-group .MuiSelect-select:focus {\n    background-color: var(--darkGreen);\n    color: var(--white);\n    \n}\n\n.profile-modal .form-group .MuiOutlinedInput-notchedOutline {\n    border-color: rgb(255 255 255/40%);\n}\n\n.profile-modal .form-group .MuiSelect-icon {\n    fill: rgb(255 255 255/40%);\n}\n\n.profile-modal .form-group .dropdown {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
